/* unplugin-vue-components disabled */import script from "./breadcrumb.vue?vue&type=script&lang=js"
export * from "./breadcrumb.vue?vue&type=script&lang=js"

import "./breadcrumb.vue?vue&type=style&index=0&id=13709f34&lang=scss"

const __exports__ = script;

export default __exports__